"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingPayoutStatusEnum = void 0;
/** @deprecated possibly the same as BillingOperationStatusEnum  */
var BillingPayoutStatusEnum;
(function (BillingPayoutStatusEnum) {
  /** ожидает */
  BillingPayoutStatusEnum[BillingPayoutStatusEnum["pending"] = 3] = "pending";
  /** исполняется */
  BillingPayoutStatusEnum[BillingPayoutStatusEnum["processing"] = 4] = "processing";
  /** завершена успешно */
  BillingPayoutStatusEnum[BillingPayoutStatusEnum["succeed"] = 5] = "succeed";
  /** отменена */
  BillingPayoutStatusEnum[BillingPayoutStatusEnum["canceled"] = 6] = "canceled";
  /** завершилась с ошибкой */
  BillingPayoutStatusEnum[BillingPayoutStatusEnum["failed"] = 7] = "failed";
})(BillingPayoutStatusEnum = exports.BillingPayoutStatusEnum || (exports.BillingPayoutStatusEnum = {}));
